import { Button } from "@mui/material";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";

import TemplateForm from "components/form/TemplateForm";

import { SaveContextProvider } from "context/save";

import useSaveUpdateWithSnackbar from "hooks/useSaveUpdateWithSnackbar";

function ButtonSave() {
    const { onButtonClick } = useSaveUpdateWithSnackbar({
        successMsg: "Template creato con successo",
        errorMsg: "Errore nella creazione del template",
        navigateTo: { link: "/templates/:templateId/modifica", id: "templateId" },
    });

    return (
        <GridItem>
            <GridRow justifyContent={"right"}>
                <GridItem>
                    <Button variant={"contained"} onClick={onButtonClick}>
                        Salva
                    </Button>
                </GridItem>
            </GridRow>
        </GridItem>
    );
}

function NuovoTemplate() {
    return (
        <GridColumn className={"template-page"}>
            <SaveContextProvider>
                <GridRow justifyContent={"space-between"} alignItems={"end"}>
                    <GridItem>
                        <GridRow>
                            <GridItem>
                                <h1>Nuovo template</h1>
                            </GridItem>
                        </GridRow>
                    </GridItem>

                    <GridItem>
                        <ButtonSave />
                    </GridItem>
                </GridRow>

                <TemplateForm />
            </SaveContextProvider>
        </GridColumn>
    );
}

export default NuovoTemplate;
